import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';

class ReceptoresSearch extends Component {
  handleOnKeywordChange = (keyword) => {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      search: keyword,
    });
  };

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  };

  render() {
    const {
      filters: { search },
    } = this.props.list;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <SearchInput
          onKeywordChange={this.handleOnKeywordChange}
          onClear={this.handleOnSearchClear}
          value={search}
        />
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.receptores.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.receptores.list };
};

export default connect(useStore, mapState, mapActions)(ReceptoresSearch);
